import React, { useState } from 'react';
import { toast } from 'sonner';
import { CalendarPlus } from 'lucide-react';

const IN = 'h-9 rounded-md border border-slate-200 px-2 text-sm';

// Trash / cancelled card: put the booking back on the calendar on a new date.
export const RebookButton = ({ item, authFetch, onDone }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(item.booking?.date || '');
  const [time, setTime] = useState(item.booking?.time || '09:00');
  const [mail, setMail] = useState(!!item.email);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await authFetch('post', `/admin/estimate/${item.id}/rebook`, { date, time, email_customer: mail });
      toast.success(`Rebooked for ${data.date} at ${data.time}.${data.emailed ? ' Customer emailed.' : ''}`);
      setOpen(false);
      onDone?.();
    } catch (e) { toast.error(typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : "Couldn't rebook."); }
    finally { setBusy(false); }
  };
  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold px-3 py-1.5 rounded-md" data-testid={`rebook-btn-${item.ref}`}>
        <CalendarPlus className="w-3.5 h-3.5" /> Rebook on a new date
      </button>
    );
  }
  return (
    <div className="w-full mt-2 rounded-md border border-emerald-300 bg-emerald-50/50 p-2 flex flex-wrap items-end gap-2" data-testid={`rebook-form-${item.ref}`}>
      <label className="text-[10px] font-bold text-slate-500">New date<input type="date" value={date} onChange={(e) => setDate(e.target.value)} className={`${IN} block`} data-testid={`rebook-date-${item.ref}`} /></label>
      <label className="text-[10px] font-bold text-slate-500">Time<input type="time" value={time} onChange={(e) => setTime(e.target.value)} className={`${IN} block`} data-testid={`rebook-time-${item.ref}`} /></label>
      {item.email && <label className="text-xs text-slate-700 inline-flex items-center gap-1.5 h-9"><input type="checkbox" checked={mail} onChange={(e) => setMail(e.target.checked)} data-testid={`rebook-email-${item.ref}`} /> Email customer the booking</label>}
      <button type="button" onClick={() => setOpen(false)} className="h-9 px-3 rounded-md border border-slate-200 bg-white text-xs font-bold">Back</button>
      <button type="button" onClick={submit} disabled={busy || !date || !time} className="h-9 px-3 rounded-md bg-emerald-600 text-white text-xs font-bold disabled:opacity-50" data-testid={`rebook-confirm-${item.ref}`}>{busy ? 'Rebooking…' : 'Rebook'}</button>
    </div>
  );
};
